<app-base-template (modal)="openModal(content)" (searchmodal) = "searchModal()" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getNewTableData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [showSearch]="showSearch" [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Client User Role Map</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group" [hidden]="notAdmin">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="clientSelected"
              (change)="onClientChange($event.target.selectedIndex)">
        <option *ngFor="let client of clients" [value]="client.id">{{client.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="roleSelected"
              (change)="onRoleChange($event.target.selectedIndex)">
        <option *ngFor="let rl of role" [value]="rl.id">{{rl.name}}</option>
      </select>
    </div>
    <!-- <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="userSelected"
              (change)="onUserChange($event.target.selectedIndex)">
        <option *ngFor="let usr of usrs" [value]="usr.id">{{usr.name}}</option>
      </select>
    </div> -->

    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" placeholder="Enter Login ID OR Name"
             [(ngModel)]="userSelected"
             matInput [formControl]="searchUser"[matAutocomplete]="auto"
            >
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getUserDetails()">
          <mat-option *ngIf="isLoading" class="is-loading">
              <mat-spinner diameter="50"></mat-spinner>
          </mat-option>
          <ng-container *ngIf="!isLoading">
              <mat-option *ngFor="let user of usrs" [value]="user.login_name">
                {{ user.name }} - {{user.login_name}}
              </mat-option>
          </ng-container>
      </mat-autocomplete>
  </div>




  <div class="form-group">
    <input type="text" class="form-control radius-0 font-13" placeholder="User Name" readonly
           [(ngModel)]="userName">
</div>

  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>

<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>

  </div>
  <div class="modal-body">
      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder=" Enter User Name"
                 [(ngModel)]="userSelected1">
      </div>
  </div>
  <div class="modal-footer pad-8">
          <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
          <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>

  </ng-template>
<notifier-container></notifier-container>

